import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { fetchXeroContacts } from '../../services/api/accounts-xero';
import { xeroContactsListFromResponse } from '../../utils/xeroInvoicing';

function xeroContactsQueryKey(accountId) {
  const id = accountId ? Number(accountId) : null;
  return ['xero-contacts', id];
}

// enabled — “Xero integration exists” (true/false).
const useXeroContactsForInvoicing = (accountId, enabled) => {
  const queryKey = useMemo(() => xeroContactsQueryKey(accountId), [accountId]);

  const { data: contacts = [], isError: fetchFailed, refetch } = useQuery(
    queryKey,
    () => fetchXeroContacts({ accountId: Number(accountId) }),
    {
      enabled: !!(enabled && accountId),
      select: xeroContactsListFromResponse
    }
  );

  return { contacts, fetchFailed, refetch };
};

export default useXeroContactsForInvoicing;
